import axios from './apiClient';

function getAll() {
    return axios.get('Products');
}
function createProduct(product) {
    return axios.post('Products', product);
}
function editProduct(product) {
    return axios.put(`Products/${product.id}`, product);
}
function deactivateProduct(productId) {
    return axios.delete(`Products/${productId}`);
}
function reactivateProduct(productId) {
    return axios.put(`Products/${productId}/Reactivate`);
}
function createOrder(productId, order) {
    return axios.post(`Products/${productId}/Orders`, order);
}
function editOrder(productId, order) {
    return axios.put(`Products/${productId}/Orders/${order.id}`, order);
}
function deactivateOrder(productId, orderId) {
    return axios.delete(`Products/${productId}/Orders/${orderId}`);
}
function reactivateOrder(productId, orderId) {
    return axios.put(`Products/${productId}/Orders/${orderId}/Reactivate`);
}
function createActivity(productId, orderId, activity) {
    return axios.post(`Products/${productId}/Orders/${orderId}/Activities`, activity);
}
function editActivity(productId, orderId, activity) {
    return axios.put(`Products/${productId}/Orders/${orderId}/Activities/${activity.id}`, activity);
}
function deactivateActivity(productId, orderId, activityId) {
    return axios.delete(`Products/${productId}/Orders/${orderId}/Activities/${activityId}`);
}
function reactivateActivity(productId, orderId, activityId) {
    return axios.put(`Products/${productId}/Orders/${orderId}/Activities/${activityId}/Reactivate`);
}
export default {
    getAll,
    createProduct,
    editProduct,
    deactivateProduct,
    reactivateProduct,
    createOrder,
    editOrder,
    deactivateOrder,
    reactivateOrder,
    createActivity,
    editActivity,
    deactivateActivity,
    reactivateActivity
};
